import { Model } from '@vuex-orm/core';
import MatchModel from './MatchModel';
import { v4 as uuid } from 'uuid';
import {utils} from '../services/utils';

export default class CourtModel extends Model {
  static entity = 'courts';

  static fields () {
    return {
      id: this.uid(() => uuid()),
      name: this.string(''),
      order: this.number(0),
      matches: this.hasMany(MatchModel, 'court_id'),
      created_at: this.attr(null)
    };
  }

  static beforeCreate(model) {
    model.created_at = utils.nowDateString();
  }
}